import { render, staticRenderFns } from "./TagFieldLocationDisplay.vue?vue&type=template&id=3201c140"
import script from "./TagFieldLocationDisplay.vue?vue&type=script&lang=js"
export * from "./TagFieldLocationDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports